import { createContext } from "react";

// const Campaign = createContext({ campaigns: {}, setCampaigns: () => {}, });
const Campaign = createContext([{}, () => {}]);

export default Campaign;
